import { storeStructure } from '../store/reducers';
import formGroupVodGraphicManager from './formGroupVodGraphicManager';

export default {
  title: 'VoD Graphic Manager Edit',
  attributeName: "VodGraphicManagerEdit",
  createURL: 'vodgraphicmanager',
  sessionParams: [],
  getURL: 'vodgraphicmanager',
  updateURL: 'vodgraphicmanager',
  idAttribute: 'id',
  saveIdSessionNameAs: 'vodId',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  websocketChannel: 'vodDetails-vodId',
  websocketSessionParams: ['vodId'],
  websocketItem: 'vodDetails',
  formConfig: [
    formGroupVodGraphicManager,
  ],
  idUpdate: true,
};
